export default __webpack_public_path__ + "static/media/post-image.0c54a83c.png";